// 本文件由 config/CA/${city}.js 自动生成，如需修改请移步至 config/city/${city}.js
import { isIE } from "@/assets/js/utils";
import qs from "qs";
// import { isIE } from "@/assets/js/utils";

// 
let $$ = function (id) {
  return document.getElementById(id);
};
class CAcontroller {
  constructor() {
    this.isIE = isIE();
    this.caInfo = null;
    this.caInfo1 = null;
    this.EpointPDFControl = null;
    this.QZCount = null;
    this.iWebOA1 = null;
    this.localPath = null;
  }
  /**
   * @author 伟健 / 张
   * @name 初始化CA  :: 公共方法
   */
  InitSignCer() {
    let html = document.createElement("div");
    try {
      if (isIE()) {
        // Js判断为IE浏览器
        if (navigator.appName.indexOf("Internet") >= 0 || navigator.appVersion.indexOf("Trident") >= 0) {
          if (window.navigator.cpuClass == "x86") {
            html.innerHTML = ' <object classid="clsid:68210AC9-5DD1-45E1-AAC8-631FCB55456F" width="0" height="0" id="CertificateCollectionX"></object> <object id="CryptoAgent" classid="clsid:E26F6F19-7CA8-4992-9BAA-65D799E1C474" style = "display:none"></object>';
          } else {
            html.innerHTML = ' <object classid="clsid:68210AC9-5DD1-45E1-AAC8-631FCB55456F" width="0" height="0" id="CertificateCollectionX"></object> <object id="CryptoAgent" classid="clsid:E26F6F19-7CA8-4992-9BAA-65D799E1C4CA" style = "display:none"></object>';
          }
          html.style.display = "none";
          document.body.appendChild(html);
        }
      }

      this.caInfo = $$("CryptoAgent");
    } catch (e) {
      alert(e);
      return false;
    }
    return true;
  }
  // 获取CA信息 用户登陆 ，绑定ca 信息   :: 公共方法
  getCAInfo() {
    return new Promise((resolve) => {
      resolve(
        {
          certIssuerCode: this.DeviceNum(), //ca编号
          certSerialName: this.ClientSignCertCN(), //证书名称
          certSerialNo: this.ClientSignCertSN(), //证书序列号
          certValidEnd: this.CertYouXiaoQi(), //证书有效截止日期，格式yyyy
          bfjg: this.Bfjg(), //证书有效截止日期，格式yyyy
        }
      )
    })
  }
  DeviceNum() {
    try {
      var KeyNumber = this.caInfo.GetDevKeyNumInfo();
      if (!KeyNumber) {
        alert("获取UsbKey号：" + this.caInfo.GetLastErrorDesc());
        return false;
      }
      return KeyNumber;
    } catch (e) {
      console.log(e);
      return false;
    }
  }
  ClientSignCertCN() {
    try {
      var CompanyNumber = "";
      var SubjectDN = "";
      var InfoContent = this.caInfo.GetSignCertInfo("IssuerDN");
      var InfoContentDN = this.caInfo.GetSignCertInfo("SubjectDN");
      if (!InfoContent && !InfoContentDN) {
        var errorDesc = this.caInfo.GetLastErrorDesc();
        alert(errorDesc);
        return;
      }

      //CFCA
      if (InfoContent.indexOf("CFCA") != -1) {
        SubjectDN = InfoContentDN.split("@");
        CompanyNumber = SubjectDN[2];
        CompanyNumber = CompanyNumber.substr(1);
        return CompanyNumber;
      }
      //SDCA
      else if (InfoContent.indexOf("L=JINAN") != -1 || InfoContent.indexOf("OU=SDCA") != -1 || InfoContent.indexOf("CN=GOLD") != -1 || InfoContent.indexOf("CN=SDRSATestCA") != -1 || InfoContent.indexOf("CN=SDCA") != -1) {
        if (InfoContentDN.indexOf("L=QD") != -1) {
          SubjectDN = InfoContentDN.split("O=");
          CompanyNumber = SubjectDN[1];
          CompanyNumber = CompanyNumber.split("CN=")[1];
          return CompanyNumber;
        } else {
          SubjectDN = InfoContentDN.split(",")[0];
          CompanyNumber = SubjectDN.split("CN=")[1];
          return CompanyNumber;
        }
      }
      //TWCA
      else if (InfoContent.indexOf("青岛福莱易通软件有限公司") != -1 || InfoContent.indexOf("临沂市公共资源交易中心") != -1) {
        SubjectDN = InfoContentDN.split(":");
        CompanyNumber = SubjectDN[1];
        CompanyNumber = CompanyNumber.split("CN=")[1];
        return CompanyNumber;
      }
      //SHCA
      else if (InfoContent.indexOf("SHECA") != -1) {
        CompanyNumber = this.caInfo.GetSignCertInfo("SHACAOid");
      }
      //JSCA
      else if (InfoContent.indexOf("SmartCA") != -1 || InfoContent.indexOf("江苏智慧") != -1) {
        CompanyNumber = this.caInfo.GetSignCertInfo("SmartCAOid");
        return CompanyNumber;
      }
      //GFACA
      else if (InfoContent.indexOf("国富安") != -1 || InfoContent.indexOf("GFA") != -1) {
        SubjectDN = InfoContentDN.split("O=");
        CompanyNumber = SubjectDN[1];
        CompanyNumber = CompanyNumber.split(",")[0];
        return CompanyNumber;
      }
      return CompanyNumber;
    } catch (e) {
      console.log(e);
    }
  }
  ClientSignCertSN() {
    try {
      var infoContent = this.caInfo.GetSignCertInfo("SerialNumber");
      if (!infoContent) {
        var errorDesc = this.caInfo.GetLastErrorDesc();
        alert("获取证书内容：" + errorDesc);
        return false;
      }
      return infoContent;
    } catch (e) {
      console.log(e);
      return false;
    }
  }
  // 颁发机构
  Bfjg() {
    try {
      return this.caInfo.Issuer;
    } catch (ex) {
      console.log(ex);
      throw "读取证书颁发者信息出现异常，请检查锁是否插好!";
    }
  }
  CertYouXiaoQi() {
    return this.caInfo.GetSignCertInfo("CertTimeOut");
  }
  // 上传签章文件
  uploadControlInit() {

    return '';
  }
  /**
   * @author 伟健 / 张
   * @name 签章文件初始化  :: 公共方法
   */
  pdfSignInit(parentNode, domain, formData) {
    if (!parentNode) return;
    let html = document.createElement("div");
    html.innerHTML = `<object width="100%" height="700px" id="EpointPDFControl" 
        classid="clsid:39E08D82-C8AC-4934-BE07-F6E816FD47A1"
        data="data:application/x-oleobject;base64,go3gOazINEm+B/boFv1HoVRQRjAKVFBERlJlYWRlcglQREZSZWFkZXIETGVmdAMfAgNUb3ADggAFV2lkdGgDQgMGSGVpZ2h0A6QBB0NhcHRpb24SFAAAAFZuF1MBd2xRcVFEjZBupE4TZjV1UFsNZ6FSc17wU1sAE04odUIAXQAFQ29sb3IHCWNsQnRuRmFjZQxGb250LkNoYXJzZXQHD0RFRkFVTFRfQ0hBUlNFVApGb250LkNvbG9yBwxjbFdpbmRvd1RleHQLRm9udC5IZWlnaHQC9QlGb250Lk5hbWUGBlRhaG9tYQpGb250LlN0eWxlCwAOT2xkQ3JlYXRlT3JkZXIICFNob3dIaW50CQ1QaXhlbHNQZXJJbmNoAmAKVGV4dEhlaWdodAINAAA=">
        <span>未安装pdf插件</span>
         <PARAM name="RecordId" value="2000">
        </object>
    `;

    parentNode.appendChild(html);
    var maxHeight = Math.max(document.documentElement.clientHeight, document.body.clientHeight);
    this.EpointPDFControl = $$("EpointPDFControl");
    this.EpointPDFControl.style.height = maxHeight - 80 + "px";
    try {
      this.EpointPDFControl.EnableTools("打开文档;保存文档;另存为;关闭文档", "2");
      this.EpointPDFControl.EnableTools("打印文档", true);
      this.EpointPDFControl.EnableTools("电子签章", true);
      this.EpointPDFControl.EnableTools("撤销签章", "2");
      this.EpointPDFControl.EnableTools("手写签名", "2");
      this.EpointPDFControl.EnableTools("盖骑缝章", true);
      this.EpointPDFControl.EnableTools("二维条码", "2");
      this.EpointPDFControl.SetSignatureParam("BtnSignatureScanCode", "0", "");
      this.EpointPDFControl.EnableHandWriter = false;
      this.EpointPDFControl.RecordId = formData.tradeNo
      this.EpointPDFControl.FileName = formData.tradeNo
      this.EpointPDFControl.MaxFileSize = 60 * 1024
      this.EpointPDFControl.WebUrl = `${domain}apis/jinan/caupload?${qs.stringify(formData || {})}`
    } catch (e) {
      console.log(e);
      alert("CA驱动读取失败，请安装CA驱动");
      return;
    }
  }

  // 展示签章文件  :: 公共方法
  showSignFile(downUrl) {
    if (!downUrl) {
      alert("文件地址错误");
      return;
    }
    setTimeout(() => {
      setTimeout(() => {
        try {
          this.localPath = "c:\\iWebOA\\WetCtrolTest\\" + this.guid() + ".pdf";

          if (downUrl.indexOf("http") >= 0) {
            this.EpointPDFControl.WebOpenUrlFile(downUrl);
          } else {
            this.EpointPDFControl.WebOpenLocalFile(downUrl);
          }

          this.QZCount = this.GetSignCount();
        } catch (ex) {
          console.log(ex);
        }
      }, 1000);
    }, 1000);
  }
  guid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  GetSignCount() {
    var vMode = this.EpointPDFControl.SignatureMode;
    var nCount = this.EpointPDFControl.SignatureCount();
    if (vMode == 0) this.EpointPDFControl.SignatureMode = 1;
    else this.EpointPDFControl.SignatureMode = 0;
    nCount = nCount + this.EpointPDFControl.SignatureCount();
    this.EpointPDFControl.SignatureMode = vMode;
    return nCount;
  }
  /**
   * @author 伟健 / 张
   * @name 提交签章文件   :: 公共方法
   */
  submitSignFile(domain, formData, fn) {
    try {
      if (this.GetSignCount() <= this.QZCount) {
        alert("您并未签章，无需提交!");
        fn && fn(false);
        return;
      }
      try {
        this.EpointPDFControl.WebSaveLocalFile(this.localPath);
        this.EpointPDFControl.WebSave()
        fn && fn(true);
      } catch (e) {
        console.error("Error:", e);
      }
    } catch (ex) {
      console.log(ex);
    }
  }
}

export default CAcontroller;
